import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { UrlSerializer, Router } from '@angular/router';
import * as Sentry from "@sentry/angular";
// import { GlobalErrorHandler } from './global-error-handler';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http'
import { BrowserModule, provideClientHydration, withNoIncrementalHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { TrailingSlashUrlSerializer } from './trailing-slash-url-serializer';
import { AppComponent } from './app.component';
import { AuthService } from './services/auth.service';

import { BtnNormalComponent } from './shared/btn-normal/btn-normal.component';
import { HeaderComponent } from './shared/header/header.component';
import { TokenHeadersInterceptor } from 'src/utils/token.headers.interceptor';
import { LoginComponent } from './module-auth/auth/components/login/login.component';
import { InactivePlatformComponent } from './shared/inactive-platformf/inactive-platform.component';
import { FatherModalComponent } from './shared/modal/father-modal/father-modal.component';
import { GlobalErrorHandler } from './global-error-handler';
// import { CookieConsentComponent } from './shared/cookie-consent/cookie-consent.component'; // deshabilitado — selector comentado en app.component.html

export function initializeAuth(authService: AuthService) {
  return () => authService.initializeSession();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    LoginComponent,
    InactivePlatformComponent,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BtnNormalComponent,
    HeaderComponent,
    ReactiveFormsModule,
    FatherModalComponent,
    // CookieConsentComponent, // deshabilitado — no se usa actualmente
  ],
  providers: [
    provideClientHydration(
      withNoIncrementalHydration(),
      withHttpTransferCacheOptions({
        includePostRequests: false,
        includeRequestsWithAuthHeaders: false,
        filter: (req) => req.url.includes('/api/')
      })
    ),
    provideHttpClient(withFetch(),
      withInterceptors([
        TokenHeadersInterceptor
      ])
    ),
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    },
    {
      provide: UrlSerializer,
      useClass: TrailingSlashUrlSerializer
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
